export const TEST_MODE = '[Test Mode] '
